import { VIEWPOINT_URL } from 'constants/AppConstants';
import { useLocation } from 'lib/router';
import { useEffect } from 'react';

/**
 * Component to indicate users to pass access token in the standalone applications
 */
function Authorize() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.location.href = `${VIEWPOINT_URL}/myev${pathname}`;
  }, []);

  return null;
}

export default Authorize;
